// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_j4-1";
export var rowFirst = "_j4-3";
export var rowLast = "_j4-5";
export var rowMiddle = "_j4-4";
export var ticketListScroll = "_j4-2";
export var ticketStack = "_j4-0";